// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgDashboardController = function ($scope, $http, $interval, PgApplicationLogs, PgPspRequestLogs, PgNotificationLogs, PgMigrations) {
    const PeriodInDays = 5;
    const NumberOfLogsToDisplay = 10;
    const AutoRefreshIntervalInMs = 60 * 1000

    let interval = null;
    $scope.autoRefresh = false;
    
    $scope.appLogs = [];
    $scope.pspRequestLogs = [];
    $scope.notificationLogs = [];
    $scope.migrations = [];
  
    $scope.loading = {
        appLogs: true,
        pspRequestLogs: true,
        notificationLogs: true,
        migrations: true
    };
    
    $scope.loadPage = function () {

        const now = new Date();
        const filter = {
            Before: now.toISOString(),
            After: new Date(new Date().setDate(now.getDate() - PeriodInDays)).toISOString(),
            Take: NumberOfLogsToDisplay,
        };
        
        PgApplicationLogs.query({...filter, Level: "Fatal"}, function(data) {
            $scope.appLogs = data;
            $scope.loading.appLogs = false;
        });

        PgPspRequestLogs.query({...filter, Level: "Error"}, function(data) {
            $scope.pspRequestLogs = data;
            $scope.loading.pspRequestLogs = false;
        });

        PgNotificationLogs.query({...filter, Level: "Error"}, function(data) {
            $scope.notificationLogs = data;
            $scope.loading.notificationLogs = false;
        });
        
        PgMigrations.query({...filter, Statuses: ["Running", "Failed"]}, function(data) {
            $scope.migrations = data;
            $scope.loading.migrations = false;
        });
    }

    $scope.loadPage();

    $scope.toggleAutoRefresh = function () {
        $scope.autoRefresh = !$scope.autoRefresh;
        if (interval)
            $interval.cancel(interval);
        if ($scope.autoRefresh) {
            $scope.loadPage();
            interval = $interval(function () {
                $scope.loadPage();
            }, AutoRefreshIntervalInMs);
        }
    }

    $scope.$on('$destroy', function () {
        $interval.cancel(interval);
    });
};
PgDashboardController.$inject = ["$scope", "$http", '$interval', "PgApplicationLogs", "PgPspRequestLogs", "PgNotificationLogs", "PgMigrations"];
